import React from 'react';

const Orthophotos = ({ selectedOrthophoto }) => {
  return (
    <section id="orthophotos">
      {selectedOrthophoto ? (
        <iframe
          src={selectedOrthophoto}
          title="Selected Orthophoto"
          className="orthophoto-viewer"
        />
      ) : (
        <p>No orthophoto selected</p>
      )}
    </section>
  );
};

export default Orthophotos;
